import { TableHeadersType } from '../tableHeadersType';

export const OTHERS_INVOICES_LIST_HEADERS: TableHeadersType[] = [
  {
    "label": "DOCUMENT ID",
    "value": "others_id",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "DOCUMENT DATE",
    "value": "date_of_invoice",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "DETAILS",
    "value": "payment",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "BRANCH",
    "value": "branch_details",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ATTACHMENTS",
    "value": "upload",
    "defaultChecked": true,
    "checked": true
  },
  /*  {
     "label": "Last Updated At",
     "value": "updated_at",
     "defaultChecked": true,
     "checked": true
   }, */
  {
    "label": "MODIFIED BY",
    "value": "company_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "APPROVED BY",
    "value": "approved_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Created At",
    "value": "created_at",
    "defaultChecked": true,
    "checked": true
  }
]

export const EXPENSES_INVOICES_LIST_HEADERS: any[] = [
  {
    "label": "NAME",
    "value": "supplier_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "INVOICE NO.",
    "value": "voucher_invoice_number",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "INVOICE DATE",
    "value": "voucher_invoice_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "TOTAL AMOUNT",
    "value": "net_amount",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ATTACHMENTS",
    "value": "upload",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "MODIFIED BY",
    "value": "company_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "APPROVED BY",
    "value": "approved_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "PAYMENT STATUS",
    "value": "payment_status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Created At",
    "value": "created_at",
    "defaultChecked": true,
    "checked": true
  }
]
export const REVENUES_INVOICES_LIST_HEADERS: any[] = [
  {
    "label": "NAME",
    "value": "customer_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "INVOICE NO.",
    "value": "voucher_invoice_number",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "INVOICE DATE",
    "value": "voucher_invoice_date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "TOTAL AMOUNT",
    "value": "net_amount",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ATTACHMENTS",
    "value": "upload",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "MODIFIED BY",
    "value": "company_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "APPROVED BY",
    "value": "approved_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "PAYMENT STATUS",
    "value": "payment_status",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Created At",
    "value": "created_at",
    "defaultChecked": true,
    "checked": true
  }
]

export const BILL_OF_MATERIAL_INVOICES_LIST_HEADERS=[
  {
    "label": "DOCUMENT NO",
    "value": "document_no",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "DATE",
    "value": "date",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "PRIMARY ITEM",
    "value": "primary_item",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "PRIMARY QTY",
    "value": "quantity",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "AMOUNT",
    "value": "amount",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "ATTACHMENT",
    "value": "attachment",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "MODIFIED BY",
    "value": "modified_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "APPROVED BY",
    "value": "approved_by",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "COMMENT",
    "value": "comment",
    "defaultChecked": true,
    "checked": true
  },
  
]

export const BULK_UPLOAD_HISTORY_LIST_HEADERS=[
  {
    "label": "File Name",
    "value": "file_name",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "File Url",
    "value": "file_url",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Stage",
    "value": "stage",
    "defaultChecked": true,
    "checked": true,
    "width":"80px"
  },
  {
    "label": "Uploaded At",
    "value": "created_at",
    "defaultChecked": true,
    "checked": true
  },
  {
    "label": "Updated At",
    "value": "updated_at",
    "defaultChecked": true,
    "checked": true
  },

]